module.exports = __webpack_public_path__ + "static/media/melo3.d9444646.ogg";